function isDarkColor(bgColor: string) {
  // Convert hex to RGB
  let color = bgColor.replace("#", "");
  if (color.length === 3) {
    color = color
      .split("")
      .map((c) => c + c)
      .join("");
  }
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  // 👵
  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    return false;
  }

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
}

export function getLegibleTextColor(bgColor: string) {
  // Return black for light backgrounds, white for dark backgrounds
  return isDarkColor(bgColor) ? "#FFFFFF" : "#000000";
}

export function getHoverStateColor(bgColor: string) {
  let color = bgColor.replace("#", "");
  if (color.length === 3) {
    color = color
      .split("")
      .map((c) => c + c)
      .join("");
  }
  let r = parseInt(color.substring(0, 2), 16);
  let g = parseInt(color.substring(2, 4), 16);
  let b = parseInt(color.substring(4, 6), 16);
  // 👵
  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    // Default hover color
    return "#dedede90";
  }

  if (isDarkColor(bgColor)) {
    // Lighten each channel by 50%
    r = Math.min(255, Math.floor(r * 1.5));
    g = Math.min(255, Math.floor(g * 1.5));
    b = Math.min(255, Math.floor(b * 1.5));
  } else {
    // Darken each channel by 10%
    r = Math.max(0, Math.floor(r * 0.9));
    g = Math.max(0, Math.floor(g * 0.9));
    b = Math.max(0, Math.floor(b * 0.9));
  }

  // Convert back to hex
  const toHex = (n: number) => n.toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export function getSecondaryTextColor(bgColor: string) {
  return `${getLegibleTextColor(bgColor)}90`;
}

export function getSeparatorColor(bgColor: string) {
  return `${getLegibleTextColor(bgColor)}50`;
}
